let esJquery = class {
  constructor(selector) {

    console.log('%c typeof selector - ','color: #aaaaaa;', typeof selector, selector);
    if (typeof selector == 'string') {

      this.$el = document.querySelector(selector);
      this.$els = document.querySelectorAll(selector);
    } else {

      this.$el = selector;

      if(isNodeList(selector)){
        this.$el = selector[0];
      }
      this.$els = [];

      if(isNodeList(selector)){

        selector.forEach((_el)=>{

          this.$els.push(_el);
        })
      }else{

        this.$els.push(this.$el);
      }


    }
  }

  hide() {

    this.$els.forEach(function (el) {
      el.style.display = 'none';
    });
  }

  clone() {
    // -- @only works on first element
    console.log('clone', this.$el);

    const cln = this.$el.cloneNode(true);
    this.$el.parentNode.appendChild(cln)
    return cln;
  }
  show() {

    this.$els.forEach(function (el) {
      el.style.display = '';
    });
  }

  addClass(arg) {

    // console.log('addClass',this.$el, this.$els, arg);
    // this.$el.classList.add(arg);


    this.$els.forEach(function (el3) {
      el3.classList.add(arg);
    });
    return this;
  }

  prepend(html) {
    if (typeof html == 'string') {

      const _tempKid = document.createElement("div");
      // _tempKid.innerHTML = html;


      this.$els.forEach(function (el) {
        try {

          el.appendChild(_tempKid);
          el.insertBefore(_tempKid, el.firstChild);
          _tempKid.outerHTML = html;
        } catch (err) {
          console.log('something went wrong .. ', err, this, el);
        }
      })
    }
  }

  find(selector) {

    console.log('this.$el.querySelectorAll(selector) - ',this.$el.querySelectorAll(selector));
    return new esJquery(this.$el.querySelectorAll(selector));
  }
  append(html) {
    if (typeof html == 'string') {

      const _tempKid = document.createElement("div");
      _tempKid.innerHTML = html;


      this.$els.forEach(function (el) {
        try {

          el.appendChild(_tempKid);
        } catch (err) {
          console.log('something went wrong .. ', err, this, el);
        }
      })
    }
  }

  on(evt, sel, handler) {

    // console.log(evt,sel,handler,this.$el);
    this.$el.addEventListener(evt, function (event) {
      var t = event.target;
      while (t && t !== this) {
        if (t.matches(sel)) {
          // console.log('t - ', t);
          handler.call(t, event);
        }
        t = t.parentNode;
      }
    });
    return this;
  }

  hasClass(arg) {
    return this.$el.classList.contains(arg);
  }
  html() {

    const attrArgs = arguments;
    if (attrArgs.length == 0) {
      return this.$el.innerHTML;
    }
    if (attrArgs.length == 1) {

      this.$el.innerHTML = attrArgs[0];

      return this;
    }
  }

  getLast() {
    console.log(this, this.$els);

    if(this.$els.length){
      return $es(this.$els[this.$els.length - 1]);
    }
    return null;
    // return
  }
  attr() {
    const attrArgs = arguments;
    if (attrArgs.length == 0) {
      console.log('no attrArgs.. ');
    }
    if (attrArgs.length == 1) {
      return this.$el.getAttribute(attrArgs[0]);
    }
    if (attrArgs.length == 2) {
      this.$els.forEach(function (el) {
        el.setAttribute(attrArgs[0], attrArgs[1]);
      });
    }

    return this;
    // console.log('addClass',this.$el, this.$els, arg);
    // this.$el.classList.add(arg);


  }

  remove() {

    console.log('this.$el - ', this.$el);
    this.$el.remove();
  }
  parent() {

    return $es(this.$el.parentNode);
  }
  getEl() {

    return this.$el;
  }

  serialize( ){
    var form = this.$el;
    var field, query='';
    if(typeof form == 'object' && form.nodeName == "FORM"){
      for(var i=0; i<=form.elements.length-1; i++){
        field = form.elements[i];
        if(field.name && field.type != 'file' && field.type != 'reset'){
          if(field.type == 'select-multiple'){
            for(var j=0; j<=form.elements[i].options.length-1; j++){
              if(field.options[j].selected){
                query += '&' + field.name + "=" + encodeURIComponent(field.options[j].value).replace(/%20/g,'+');
              }
            }
          }
          else{
            if((field.type != 'submit' && field.type != 'button')){
              if((field.type != 'checkbox' && field.type != 'radio') || field.checked){
                query += '&' + field.name + "=" + encodeURIComponent(field.value).replace(/%20/g,'+');
              }
            }
          }
        }
      }
    }
    return query.substr(1);
  }
};

function isNodeList(nodes) {
  var stringRepr = Object.prototype.toString.call(nodes);

  return typeof nodes === 'object' &&
    /^\[object (HTMLCollection|NodeList|Object)\]$/.test(stringRepr) &&
    (typeof nodes.length === 'number') &&
    (nodes.length === 0 || (typeof nodes[0] === "object" && nodes[0].nodeType > 0));
}

const $es = (arg) => {
  // todo: actually convert to a class maybe..


  return new esJquery(arg)
  // return document.querySelector(arg);
};
window.es_ajax = function(pargs) {
  var margs = {
    'type':'GET',
    'url':'/',
    'data':{},
    'success':null
  };

  if(pargs){
    margs = Object.assign(margs, pargs);
  }

  let xhr = new XMLHttpRequest();

  xhr.open(margs.type, margs.url);
  var form_data = new FormData();

  // console.log('margs.data - ', margs.data,pargs,margs);
  for ( var key in margs.data ) {
    form_data.append(key, margs.data[key]);
  }
  // console.log('form_data - ', form_data);

  xhr.send(form_data);
  xhr.addEventListener('load', handle_loaded);

  function handle_loaded(e){

    // console.log('laded xhr - ',e,xhr);
    if (xhr.status != 200) {

      // console.log('this no status - ', this,e);
    } else { // show the result
      // console.log('this - ', this,e);
      if(margs.success){
        margs.success(e, this);
      }
    }
  }


}
module.exports.$es = $es;